import classNames from "classnames";
import NavbarTop from "components/navbar/top/NavbarTop";
import NavbarVertical from "components/navbar/vertical/NavbarVertical";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
// import ProductProvider from "components/app/e-commerce/ProductProvider";
// import CourseProvider from "components/app/e-learning/CourseProvider";
// import ModalAuth from "components/authentication/modal/ModalAuth";

import { useAppContext } from "Main";

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes("kanban");
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition },
  } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    // <div className={isFluid ? "container-fluid" : "container"}>
    <div>
      {(navbarPosition === "vertical" || navbarPosition === "combo") && (
        <NavbarVertical />
      )}
      {/* <ProductProvider> */}
      {/* <CourseProvider> */}
      <div
        className={classNames("content")}
      // style={{ paddingBottom: "0.9875rem" }}
      >
        <NavbarTop />
        {/*------ Main Routes ------*/}
        <div style={{ marginTop: "0px" }}>
          <Outlet />
        </div>
        {/* {!isKanban && <Footer />} */}
      </div>
      {/* </CourseProvider> */}
      {/* </ProductProvider> */}
      {/* <ModalAuth /> */}
    </div>
  );
};

export default MainLayout;
